import { render, staticRenderFns } from "./Section3Widget.vue?vue&type=template&id=33beeb35&lang=pug&"
import script from "./Section3Widget.vue?vue&type=script&lang=js&"
export * from "./Section3Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports